import React, { Component } from "react";
import "./Stepper.less";

class Stepper extends Component {
  render() {
    const { steps, currentStep } = this.props;

    return (
      <div className="stepper">
        {steps.map((step, index) => {
          const isCompleted = index + 1 < currentStep;
          const isActive = index + 1 === currentStep;

          return (
            <div
              key={index}
              className={`stepper__step ${isActive ? "active" : isCompleted ? "completed" : ""}`}
            >
              <div className="stepper__circle">
                {isCompleted ? <i className="fa fa-check" aria-hidden="true"></i> : index + 1}
              </div>
              <span className="stepper__label">{step}</span>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Stepper;